module.exports = __webpack_public_path__ + "static/media/ISO13067_10030887_001.b812f0bf.png";